import DemandsScreen from './DemandsScreen';

export default DemandsScreen;
